
import {defineComponent, inject, PropType, computed} from "vue";
import {INode} from "@/interfaces/evidence-map";
import {useMapStore} from "@/mixins/mapStore";

export default defineComponent({
  name: "NodeListTile",
  props: {
    node: {
      type: Object as PropType<INode>
    },
    searchMode: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
    }
  },
  setup(props) {
    const mapStore = useMapStore()
    const active = computed<boolean>(() => props.searchMode ? props.active : mapStore.state.nodePath.findIndex((x: INode) => x.id == props.node.id) != -1)
    const onNodeClick = () => {
      mapStore.onNodeClick(props.node)
    }
    return {
      onNodeClick,
      active
    }
  }

})
